export const registrationState = {
    heartRunnerOrgInfo:[],
    isLoading: false,
    statusCode:''
    
}
